function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fill: "#004152",
  fillRule: "evenodd",
  d: "M12.61 3.356c.653.702.951 1.68 1.05 2.618h.002c-.343.267-.628.595-.893.965-1.251 1.73-.848 4.521-.68 5.14-1.018.862 1.088 3.43 1.256 3.595.168.205 1.302 2.15-.713 2.649l-.543.244c-.54.242-1.009.39-1.446.53-.56.177-1.068.338-1.6.656-.258.16-.467.339-.637.528H0v-.07c-.002-.666-.007-2.178 1.54-3.03.503-.301 1.233-.473 1.992-.65.667-.157 1.356-.32 1.931-.579l.544-.243c1.587-1.648-.292-4.354-.46-4.558-.168-.166-1.17-1.407-.504-2.213-.167-.619-.835-3.116.416-4.847.707-.99 1.91-1.48 3.575-1.52 1.587-.37 2.784-.121 3.575.785zm1.029 4.05c.714-.99 1.928-1.483 3.611-1.521 1.604-.371 2.812-.122 3.612.784 1.393 1.481 1.184 4.187.88 5.172.476.21.316 1.341-.465 2.54l-.113.223c-.087.174-.175.348-.266.52-.754 1.31-1.28 2.993-.817 3.899.202.174.736.477 1.025.587.548.265 1.11.36 1.658.453.647.11 1.274.216 1.833.594.462.326 1.403 1.529 1.403 2.937H8.126v-.07c-.002-.667-.008-2.178 1.555-3.03.509-.3 1.248-.472 2.015-.65.673-.157 1.368-.318 1.948-.576l.548-.245c1.604-1.647-.294-4.353-.464-4.559-.169-.165-1.18-1.407-.509-2.213-.169-.619-.843-3.116.42-4.845z",
  clipRule: "evenodd"
});

var _ref3 = React.createElement("ellipse", {
  cx: 17.063,
  cy: 23.594,
  fill: "#004152",
  rx: 8.938,
  ry: 1.083
});

var _ref4 = React.createElement("path", {
  fill: "#004152",
  d: "M8.938 19.237C4 19.237 0 19.722 0 20.321c0 .54 3.353.987 7.613 1.07 0 0 .113-.359.803-1.098.69-.738 1.754-1.046 1.754-1.046-.403-.006-.814-.01-1.232-.01z"
});

var SvgPassengers = function SvgPassengers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPassengers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/passengers.38262757.svg";
export { ForwardRef as ReactComponent };